import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g transform="scale(0.75 0.75)">
    <rect width="32" height="32" rx="4" fill={fill} />
    <path
      d="M10 22.3148L14.5814 15.1574L10.3261 8H13.7499L16.065 12.5651C16.277 12.989 16.4237 13.3151 16.5052 13.527C16.652 13.1846 16.815 12.8422 16.9781 12.5162L19.4562 8H22.6029L18.2661 15.1574L22.7333 22.38H19.4725L16.7824 17.3747C16.6602 17.1612 16.5565 16.9376 16.4726 16.7063C16.3947 16.9348 16.2908 17.1536 16.1629 17.3584L13.2608 22.3148H10Z"
      fill="white"
    />
  </g>
);

export default Icon;
